export default function initVideoDintroduction() {
    const lecteursVideos = document.querySelectorAll('.block-full-video-player');

    if (!lecteursVideos) {
        return;
    }

    lecteursVideos.forEach((lecteurVideo) => {
        const lecteurVideoBtn = lecteurVideo.querySelector('.play');

        lecteurVideoBtn.addEventListener('click', (e) => {
            e.preventDefault();

            const video = lecteurVideo.querySelector('.video-player');

            const videoEmbed = lecteurVideo
                .querySelector('.video-player div')
                .getAttribute('data-embed-code')
                .replace('?feature=oembed', '?feature=oembed&autoplay=1');

            // json_decode
            const videoEmbedDecode = JSON.parse(videoEmbed);

            video.innerHTML = videoEmbedDecode;

            lecteurVideo.classList.add('is-playing');
        });
    });
}
